define([], function () {
	var HeroImage = function () {
		var self = this;

		self.init = function(heroElement) {
			if (!heroElement) {
				console.error('[hero_image]: no valid hero image node found')
				return
			}

			if (!window.ERV.ViewData.TopImagePartial) {
				console.error('[hero_image]: TopImagePartial data was not provided')
				return 
			}
			
			heroElement.sources = [
				{
					srcset: window.ERV.ViewData.TopImagePartial.imageUrl.small,
					media: '(max-width: 1023px)',
				},
				{
					srcset: window.ERV.ViewData.TopImagePartial.imageUrl.big,
					media: '(min-width: 1024px)',
				}
			]

			heroElement.src = window.ERV.ViewData.TopImagePartial.imageUrl.big
		}
	}

	return HeroImage
});